<template>
  <div id="proposta-web">
    <div v-if="loading || loadingParceiros || loadingOportunidadeDimensionamento || loadingUnidadeConsumidora || loadingContasEnergia || loadingGraficoEstimativa">
      <div class="container mt-2">
        <v-row align="center">
          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
            <v-skeleton-loader height="50px" type="image"></v-skeleton-loader>
          </v-col>
          <v-col cols="4" sm="9" md="9" lg="9" xl="9" class="d-none d-md-block">
            <v-row no-gutters align="center" justify="end">
              <v-skeleton-loader type="button" class="mr-2"></v-skeleton-loader>
              <v-skeleton-loader type="button" class="mr-2"></v-skeleton-loader>
              <v-skeleton-loader type="button" class="mr-2"></v-skeleton-loader>
              <v-skeleton-loader type="button" class="mr-2"></v-skeleton-loader>
              <v-skeleton-loader type="button" class="mr-2"></v-skeleton-loader>
              <v-skeleton-loader type="button"></v-skeleton-loader>
            </v-row>
          </v-col>
        </v-row>
        <div class="mt-2 text-center" v-for="i in 4" :key=i>
          <v-skeleton-loader type="list-item"></v-skeleton-loader>
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="propostaInvalida">
        <div class="py-15">
          <div class="text-h1 text-center text-primary">
            Proposta expirada ou inexistente. <v-icon color="primary" large>sentiment_dissatisfied</v-icon>
          </div>
        </div>
      </div>
      <div v-else>
        <div id="inicio"></div>
        <div id="topo" class="px-md-2" :style="'background-color:'+template.cores[1].tcc_cor">
          <div class="container px-0 py-1">
            <v-row align="center" justify="center">
              <v-col cols="8" sm="3" md="3" lg="3" xl="3">
                <a @click="scrollToSection('inicio')">
                  <img v-if="template.imagens[0].tei_imagem !== null" :src="template.imagens[0].tei_imagem" alt="Logo">
                  <img v-else src="@assets/img/logo.png" alt="Logo">
                </a>
              </v-col>
              <v-col cols="4" sm="9" md="9" lg="9" xl="9">
                <div class="d-none d-md-block">
                  <ul class="pl-0 d-flex align-center justify-space-between">
                    <li v-for="(item, index) in menu" :key="index" :class="showOrHideMenu(item.slug)">
                      <a class="pa-2" @click="scrollToSection(item.slug)" :style="'color:'+template.cores[0].tcc_cor">
                        {{item.nome}}
                      </a>
                    </li>
                    <li>
                      <v-btn :style="'color:'+template.cores[3].tcc_cor" :color="template.cores[2].tcc_cor" @click="scrollToSection('download')">
                        Download
                      </v-btn>
                    </li>
                  </ul>
                </div>
                <div class="d-block d-md-none text-right pr-3">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        rounded
                        v-bind="attrs"
                        v-on="on"
                        class="px-2"
                      >
                        <v-icon>menu</v-icon>
                        <span class="d-none d-sm-block">Menu</span>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item v-for="(item, index) in menu" :key="index" :class="showOrHideMenu(item.slug)">
                        <v-list-item-title @click="scrollToSection(item.slug)" :style="'color:'+template.cores[0].tcc_cor">{{ item.nome }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title @click="scrollToSection('download')">
                          <v-btn :color="template.cores[2].tcc_cor" class="w-100" :style="'color:'+template.cores[3].tcc_cor">
                            Download
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="menu_space"></div>
        <section class="content_space text-center topo_proposta page_break" :style="template.imagens[1].tei_imagem !== undefined ? `background-image: url('${template.imagens[1].tei_imagem}')` : `background-image: url('${require('@/assets/img/bg_topo.jpg')}')`">
          <div class="container">
            <div class="content_move_topo text-center text-white">
              <div class="text-h0 mb-3" :style="'color:'+template.cores[4].tcc_cor">
                {{template.textos[0].tet_texto}}
              </div>
              <div class="text-h2 mb-3">
                Elaborada para {{proposta.cliente.cli_nome}}
              </div>
              <div class="text">
                Proposta criada em <b>{{$root.Formatter.formatDate(proposta.pos_criado_em)}}</b> <br>
                Proposta válida até <b>{{$root.Formatter.formatDate(proposta.pos_validade)}}</b>
              </div>
              <div class="text text--thin mt-2">
                Número da proposta: <b>P{{proposta.pos_id}}</b>
              </div>
            </div>
          </div>
        </section>
        <section id="quem-somos" class="text-center content_space">
          <div class="container">
            <div class="text-h0 mb-3" :style="'color:'+template.cores[6].tcc_cor">
              Quem somos
            </div>
            <div class="text-h2">
              {{template.textos[1].tet_texto}}
            </div>
            <div class="text mt-5">
              {{template.textos[2].tet_texto}}
            </div>
            <div class="logo_quem_somos mt-8 text-center" v-if="proposta.integrador.int_imagem">
              <img :src="proposta.integrador.int_imagem" alt="Logo">
            </div>
            <div class="text-center mt-4">
              <div class="d-inline-block text-left text">
                <div class="text-center ">
                  <b v-if="proposta.integrador.int_nome_fantasia || proposta.integrador.int_nome">
                    {{proposta.integrador.int_nome_fantasia ? proposta.integrador.int_nome_fantasia : proposta.integrador.int_nome}}
                  </b>
                </div>
                <br>
                <br>
                <div class="pl-md-5">
                  <span v-if="proposta.integrador.int_cnpj">
                    <v-icon>apartment</v-icon> CNPJ: <b>{{proposta.integrador.int_cnpj}}</b> <br>
                  </span>
                  <span v-if="proposta.integrador.int_rua || proposta.integrador.int_numero || proposta.integrador.int_bairro">
                    <v-icon>map</v-icon> {{proposta.integrador.int_rua ? proposta.integrador.int_rua + ', ' : ''}}
                    {{proposta.integrador.int_numero ? proposta.integrador.int_numero + ', ' : ''}}
                    {{proposta.integrador.int_bairro}} <br>
                  </span>
                  <span v-if="proposta.integrador.int_cidade || proposta.integrador.int_uf || proposta.integrador.int_cep">
                    <v-icon>place</v-icon> {{proposta.integrador.int_cidade ? proposta.integrador.int_cidade + ', ' : ''}}
                    {{proposta.integrador.int_uf ? proposta.integrador.int_uf + ', ' : ''}}
                    {{proposta.integrador.int_cep}} <br>
                  </span>
                  <span v-if="proposta.integrador.int_celular">
                    <v-icon>perm_phone_msg</v-icon> Telefone: <b><a class="text-primary" :href="'tel:'+proposta.integrador.int_celular" target="_blank">{{proposta.integrador.int_celular}}</a></b> <br>
                  </span>
                  <span v-if="proposta.integrador.int_email">
                    <v-icon>email</v-icon> Email: <b><a class="text-primary" :href="'mailto:'+proposta.integrador.int_email" target="_blank">{{proposta.integrador.int_email}}</a></b> <br>
                  </span>
                  <!-- <span>
                    <v-icon>language</v-icon> Site: <b><a class="text-primary" href="https://website.com.br" target="_blank">https://website.com.br</a></b>
                  </span> -->
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="nossos-parceiros" class="text-center content_space" v-if="parceiros.length > 0">
          <div class="container">
            <div class="text-h0 mb-3" :style="'color:'+template.cores[6].tcc_cor">
              Nossos parceiros
            </div>
            <div class="text">
              {{template.textos[3].tet_texto}}
            </div>
            <v-row class="mt-8 parceiros_imagens" no-gutters align="center" justify="center">
              <img v-for="(item,index) in parceiros" :key="index" :src="item.par_logo" :alt="item.par_nome" class="mx-1">
            </v-row>
          </div>
        </section>
        <section id="oque-nos-move" class="content_space" :style="template.imagens[2].tei_imagem !== undefined ? `background-image: url('${template.imagens[2].tei_imagem}')` : `background-image: url('${require('@/assets/img/bg.jpg')}')`">
          <div class="container">
            <div class="content_move text-center">
              <div class="text-h0 mb-3" :style="'color:'+template.cores[5].tcc_cor">
                O que nos move?
              </div>
              <div class="text mb-3 margem_print_move" :style="'color:'+template.cores[5].tcc_cor">
                {{template.textos[4].tet_texto}}
              </div>
              <v-row align="start" justify="center" class="my-4" :style="'color:'+template.cores[5].tcc_cor">
                <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                  <div class="text-center mb-1">
                    <v-icon color="primary" x-large>solar_power</v-icon>
                  </div>
                  <div class="text-h2 mb-3">
                    <b>
                      Nossa visão
                    </b>
                  </div>
                  <div class="text">
                    {{template.textos[5].tet_texto}}
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                  <div class="text-center mb-1">
                    <v-icon color="primary" x-large>rocket_launch</v-icon>
                  </div>
                  <div class="text-h2 mb-3">
                    <b>
                      Nossa missão
                    </b>
                  </div>
                  <div class="text">
                    {{template.textos[6].tet_texto}}
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                  <div class="text-center mb-1">
                    <v-icon color="primary" x-large>security</v-icon>
                  </div>
                  <div class="text-h2 mb-3">
                    <b>
                      Nossos valores
                    </b>
                  </div>
                  <div class="text">
                    {{template.textos[7].tet_texto}}
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </section>
        <section id="descricao-da-proposta" class="content_space text-white page_break">
          <div class="container">
            <div class="text-h0 text-center mb-3 mb_title">
              Detalhes da proposta
            </div>
            <div class="text-h1 text-center mb-3" v-if="dadosContasEnergia.length > 0">
              Usina fotovoltaica
            </div>
            <div class="text text-center mb-3" v-if="dadosContasEnergia.length > 0">
              Contas de energia consideradas
            </div>
            <v-simple-table class="mb-3 border_table_dark table_dimensionamento" dark v-if="dadosContasEnergia.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center border_table_dark_right">
                      Conta
                    </th>
                    <th class="text-center border_table_dark_right">
                      Unidade Consumidora
                    </th>
                    <th class="text-center border_table_dark_right">
                      Consumo médio mensal (kWh)
                    </th>
                    <th class="text-center border_table_dark_right">
                    Consumo mínimo (kWh)
                    </th>
                    <th class="text-center">
                      Preço do kWh (R$)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in dadosContasEnergia" :key="index">
                    <td class="text border_table_dark_right" align="center">{{retornaModalidade(item.opc_modalidade_tarifaria)}} - {{retornaEntrada(item.opc_entrada_padrao)}}</td>
                    <td class="text border_table_dark_right" align="center">{{item.opc_unidade_consumidora}}</td>
                    <td class="text border_table_dark_right" align="center">{{$root.Formatter.floatToMoney(item.opc_consumo_mensal)}}</td>
                    <td class="text border_table_dark_right" align="center">{{$root.Formatter.floatToMoney(item.opc_consumo_minimo)}}</td>
                    <td align="center">{{$root.Formatter.floatToMoney(item.opc_valor_kwh)}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div class="text-h1 text-center mb-3 margin_print">
              Dimensionamento
            </div>
            <v-simple-table class="mb-3 border_table_dark table_dimensionamento" dark v-if="!loadingOportunidadeDimensionamento">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="text border_table_dark_right" width="50%">
                      <b>
                        Localidade da usina
                      </b>
                    </td>
                    <td class="text">
                      {{proposta.oportunidade.opu_cidade ? proposta.oportunidade.opu_cidade + '/' : ''}}{{proposta.oportunidade.opu_uf ? proposta.oportunidade.opu_uf : ''}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text border_table_dark_right" width="50%">
                      <b>
                        Tipo de estrutura
                      </b>
                    </td>
                    <td class="text">
                      {{(tiposEstrutura.filter(item => item.value === oportunidadeDimensionamento.dim_tipo_estrutura))[0].text}}
                    </td>
                  </tr>
                  <tr>
                    <td class="text border_table_dark_right" width="50%">
                      <b>
                        Irradiação Solar Diária Média Anual
                      </b>
                    </td>
                    <td class="text">
                      {{proposta.oportunidade.opu_irradiacao_diaria}} kWh/m²
                    </td>
                  </tr>
                  <tr>
                    <td class="text border_table_dark_right" width="50%">
                      <b>
                        Potência do sistema dimensionado
                      </b>
                    </td>
                    <td class="text">
                      {{oportunidadeDimensionamento.dim_potencia}} kWp
                    </td>
                  </tr>
                  <tr>
                    <td class="text border_table_dark_right" width="50%">
                      <b>
                        Energia estimada a ser gerada pela potência dimensionada (média anual)
                      </b>
                    </td>
                    <td class="text">
                      {{oportunidadeDimensionamento.dim_energia_gerar}} kWh/mês
                    </td>
                  </tr>
                  <tr>
                    <td class="text border_table_dark_right" width="50%">
                      <b>
                        Área útil necessária para a instalação (estimada)
                      </b>
                    </td>
                    <td class="text">
                      {{oportunidadeDimensionamento.dim_area_util}} m²
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div class="text-h1 text-center mb-3 margem_estimativa">
              <!-- Estimativa de Consumo vs. Geração mês a mês -->
              Estimativa de geração de energia mês a mês
              <br>
              <div class="text">
                Média anual: {{dadosGraficoEstimativa.media_geracao_anula}} kWh/mês
              </div>
            </div>
            <v-card class="pa-3 mb-3" elevation="2">
              <div class="hide-print">
                <bar-chart :options="barChartOptionskWh" :height="screenWidth > 767 ? 100 : 500" :data="barChartDataEstimativa"></bar-chart>
              </div>
              <div class="grafico_print">
                <bar-chart :options="barChartOptionskWh" :height="130" :data="barChartDataEstimativa"></bar-chart>
              </div>
            </v-card>
            <div class="area_unidade_consumidora broken_paper_print" v-if="dadosUnidadeConsumidora.length > 0">
              <div class="text-h1 text-center mb-3 mt-4 margin_print">
                Unidade consumidora
              </div>
              <div class="text text-center mb-2">
                Ficará com 100% do crédito gerado
              </div>
              <div class="text text-center mb-3">
                <b>
                  *Valores estimados (não considerado possíveis cobranças de ICMS sobre a TUSD)
                </b>
              </div>
              <v-simple-table class="border_table_dark unidade_tabela" dark>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center border_table_dark_right">
                        Mês
                      </th>
                      <th class="text-center border_table_dark_right">
                        Consumo (kWh)
                      </th>
                      <th class="text-center border_table_dark_right">
                        Geração (kWh)
                      </th>
                      <th class="text-center border_table_dark_right">
                        Crédito do mês (kWh)
                      </th>
                      <th class="text-center border_table_dark_right">
                        Crédito acumulado (kWh)
                      </th>
                      <th class="text-center border_table_dark_right">
                        Fatura sem sistema (R$)
                      </th>
                      <th class="text-center">
                        Fatura com sistema (R$)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,index) in dadosUnidadeConsumidora" :key="index">
                      <td class="text border_table_dark_right" align="center">{{item.periodo}}</td>
                      <td class="text border_table_dark_right" align="center">{{item.consumo}}</td>
                      <td class="text border_table_dark_right" align="center">{{item.geracao}}</td>
                      <td class="text border_table_dark_right" align="center">{{item.credito_mes}}</td>
                      <td class="text border_table_dark_right" align="center">{{item.credito_total}}</td>
                      <td class="text border_table_dark_right" align="center">{{$root.Formatter.floatToMoney(item.fatura_sem_sistema)}}</td>
                      <td align="center">{{$root.Formatter.floatToMoney(item.fatura_com_sistema)}}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
        </section>
        <!-- broken_paper_print -->
        <section id="produtos" class="content_space" v-if="proposta && proposta.produtos && proposta.produtos.length > 0">
          <div class="container">
            <div class="text-h0 text-center mb-3" :style="'color:'+template.cores[6].tcc_cor">
              Os produtos
            </div>
            <div class="text text-center mb-3">
              {{template.textos[8].tet_texto}}
            </div>
            <v-card elevation="2">
              <v-simple-table class="border_table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center border_table_right">
                        Item
                      </th>
                      <th class="text-center border_table_right">
                        Unidade Medida
                      </th>
                      <th class="text-center border_table_right">
                        Qtde.
                      </th>
                      <th class="text-center border_table_right">
                        Valor unitário
                      </th>
                      <th class="text-center">
                        Valor total
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(prod, index) in proposta.produtos" :key="index">
                      <td class="text border_table_right" align="center">
                        {{prod.pop_nome}} <span class="text--thin" v-if="prod.pop_codigo">({{prod.pop_codigo}})</span>
                      </td>
                      <td class="text border_table_right" align="center">{{prod.pop_unidade === 1 ? 'KG' : 'UN'}}</td>
                      <td class="text border_table_right" align="center">{{prod.pop_quantidade}}</td>
                      <td class="text border_table_right" align="center">{{$root.Formatter.floatToMoney(prod.pop_valor)}}</td>
                      <td align="center">{{$root.Formatter.floatToMoney(retornaSoma(prod.pop_quantidade, prod.pop_valor))}}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
            <v-card class="mt-3 pa-3" outlined>
              <v-row align="center">
                <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                  <div class="text-h2 text-md-left text-center">
                    Valor total da proposta
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                  <div class="text-h2 text-md-right text-center text-primary">
                    {{$root.Formatter.floatToMoney(proposta.pos_total)}}
                  </div>
                  <!-- <div class="text--thin text-md-right text-center text-primary">
                    * R$ 0,26 por Wp
                  </div> -->
                </v-col>
              </v-row>
            </v-card>
            <v-card class="mt-3" elevation="0" outlined>
              <v-row align="center">
                <v-col cols="12" sm="9" md="9" lg="9" xl="9">
                  <v-row no-gutters align="center" justify="center" class="mt-md-0 mt-3" v-if="proposta.bancos && proposta.bancos.length > 0">
                    <span v-for="(ban, ind) in proposta.bancos" :key="ind">
                      <img v-if="ban.banco" :src="ban.banco.ban_logo" alt="Banco" :title="ban.banco.ban_nome" class="mx-1 bancos_imagens">
                    </span>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                  <v-card color="black" class="pa-5 h-100">
                    <div class="text-h1 text-center text-white">
                      Prazo de entrega
                    </div>
                    <div class="text-h2 text-center text-white">
                      {{proposta.pos_prazo === 0 ? 'A Combinar' : proposta.pos_prazo + ' dia' + (proposta.pos_prazo === 1 ? '' : 's')}}
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </section>
        <section id="payback" class="content_space">
          <div class="container">
            <div class="text-h0 text-center mb-3" :style="'color:'+template.cores[6].tcc_cor">
              Retorno do investimento
            </div>
            <div class="text text-center mb-3">
              {{template.textos[9].tet_texto}}
            </div>
            <v-card elevation="2" v-if="retornoInvestimento && retornoInvestimento.length > 0">
              <v-simple-table class="border_table retorno_tabela">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center border_table_right">
                        Status
                      </th>
                      <th class="text-center border_table_right">
                        Ano
                      </th>
                      <th class="text-center border_table_right">
                        Preço tarifa (R$/KWh) *
                      </th>
                      <th class="text-center border_table_right">
                        Produção de energia (KWh/ano) **
                      </th>
                      <th class="text-center border_table_right">
                        Produção de energia total (R$)
                      </th>
                      <th class="text-center border_table_right">
                        Resultado financeiro (R$)
                      </th>
                      <th class="text-center border_table_right">
                        CDB 130% CDI (R$) ***
                      </th>
                      <th class="text-center">
                        Poupança (R$) ****
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="retorno in retornoInvestimento" :key="retorno.ano">
                      <td class="text border_table_right" align="center">
                        <v-chip color="cyan" label v-if="retorno.status === 0" text-color="white">
                          Investimento
                        </v-chip>
                        <v-chip color="success" label v-else>
                          Lucro
                        </v-chip>
                      </td>
                      <td class="text border_table_right" align="center">{{retorno.ano}}</td>
                      <td class="text border_table_right" align="center">{{$root.Formatter.floatToMoney(retorno.tarifa)}}</td>
                      <td class="text border_table_right" align="center">{{retorno.producao_ano}}</td>
                      <td class="text border_table_right" align="center">{{$root.Formatter.floatToMoney(retorno.producao_valor_total)}}</td>
                      <td class="text border_table_right" align="center">{{$root.Formatter.floatToMoney(retorno.resultado_financeiro)}}</td>
                      <td class="text border_table_right" align="center">{{$root.Formatter.floatToMoney(retorno.resultado_cdb)}}</td>
                      <td align="center">{{$root.Formatter.floatToMoney(retorno.resultado_poupanca)}}</td>
                    </tr>
                    <tr>
                      <td class="text border_table_right" colspan="5" align="center">
                        Resultado líquido (descontando imposto de renda)
                      </td>
                      <td class="text border_table_right alert-success" align="center">
                        {{$root.Formatter.floatToMoney(retornoInvestimento[retornoInvestimento.length - 1].resultado_financeiro)}}
                      </td>
                      <td class="text border_table_right alert-warning" align="center">
                        {{$root.Formatter.floatToMoney(retornoInvestimento[retornoInvestimento.length - 1].resultado_cdb - (retornoInvestimento[retornoInvestimento.length - 1].resultado_cdb * 0.15))}}
                      </td>
                      <td class="text alert-danger" align="center">
                        {{$root.Formatter.floatToMoney(retornoInvestimento[retornoInvestimento.length - 1].resultado_poupanca)}}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
            <div class="text text--thin text-right mt-3">
              * Inflação anual: 4.00% <br>
              ** Conforme especificação dos fabricantes, os módulos perdem 20% de eficiência em 25 anos<br>
              *** Taxa DI: 4.40% ao ano<br>
              **** Rendimento da poupança: 3.15% ao ano
            </div>
            <div class="text-h1 text-center mt-3 broken_paper_print print_margem_fluxo" :style="'color:'+template.cores[6].tcc_cor">
              Fluxo de caixa (R$ vs. Ano)
            </div>
            <v-card class="pa-3 mt-3 mb-3" elevation="2">
              <div v-if="barChartDataTwo.datasets.length > 0" class="hide-print">
                <bar-chart :options="barChartOptionsFluxoCaixa" :height="screenWidth > 767 ? 100 : 500" :data="barChartDataTwo"></bar-chart>
              </div>
              <div class="grafico_print" v-if="barChartDataTwo.datasets.length > 0">
                <bar-chart :options="barChartOptionsFluxoCaixa" :height="130" :data="barChartDataTwo"></bar-chart>
              </div>
            </v-card>
          </div>
        </section>
        <section id="analise-investimento" class="content_space">
          <div class="container">
            <div class="text-h0 text-center mb-3" :style="'color:'+template.cores[6].tcc_cor">
              Análise do investimento
            </div>
            <div class="text text-center mb-3">
              {{template.textos[9].tet_texto}}
            </div>
            <v-row class="mt-3" align="center" justify="center">
              <v-col cols="12" sm="4" md="4" lg="4" xl="3">
                <div class="text-h1 mb-3 text-center" v-if="retornoAnalise && retornoAnalise.TIR">
                  TIR
                </div>
                <div class="text-h2 text-center text-primary" v-if="retornoAnalise && retornoAnalise.TIR">
                  <b>
                    {{retornoAnalise.TIR}}%
                  </b>
                </div>
                <v-divider class="mt-4 mb-3"></v-divider>
                <div class="text-h1 mb-3 text-center" v-if="retornoAnalise && retornoAnalise.CO2">
                  <v-icon large color="orange">factory</v-icon> {{retornoAnalise.CO2.toString().replace('.', ',')}} toneladas
                </div>
                <div class="text text-center" v-if="retornoAnalise && retornoAnalise.CO2">
                  de CO2 que não serão emitidos na atmosfera (em 25 anos)
                </div>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="3">
                <div class="text-h1 mb-3 text-center" v-if="retornoAnalise && retornoAnalise.VPL">
                  VPL
                </div>
                <div class="text-h2 text-center text-primary" v-if="retornoAnalise && retornoAnalise.VPL">
                  <b>
                    {{$root.Formatter.floatToMoney(retornoAnalise.VPL)}}
                  </b>
                </div>
                <v-divider class="mt-4 mb-3"></v-divider>
                <div class="text-h1 mb-3 text-center" v-if="retornoAnalise && retornoAnalise.arvores">
                  <v-icon large color="success">forest</v-icon> {{retornoAnalise.arvores}} árvores
                </div>
                <div class="text text-center" v-if="retornoAnalise && retornoAnalise.arvores">
                  seriam necessárias para eliminar a quantidade de CO2 da atmosfera
                </div>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="3">
                <div class="text-h1 mb-3 text-center" v-if="retornoAnalise && retornoAnalise.PAYBACK">
                  Payback
                </div>
                <div class="text-h2 text-center text-primary" v-if="retornoAnalise && retornoAnalise.PAYBACK">
                  <b>
                    {{retornoAnalise.PAYBACK}} ano
                  </b>
                </div>
                <v-divider class="mt-4 mb-3"></v-divider>
                <div class="text-h1 mb-3 text-center" v-if="retornoAnalise && retornoAnalise.arvores_valor">
                  <v-icon large color="primary">savings</v-icon> {{$root.Formatter.floatToMoney(retornoAnalise.arvores_valor)}}
                </div>
                <div class="text text-center" v-if="retornoAnalise && retornoAnalise.arvores_valor">
                  é o custo aproximado para plantar todas as {{ retornoAnalise.arvores }} árvores
                </div>
              </v-col>
            </v-row>
          </div>
        </section>
        <section id="anexos" class="content_space hide-print" v-if="proposta && proposta.anexos && proposta.anexos.length > 0">
          <div class="container">
            <div class="text-h0 text-center mb-3" :style="'color:'+template.cores[6].tcc_cor">
              Anexos
            </div>
            <ul class="pl-0">
              <li v-for="(item, i) in proposta.anexos" :key="i">
                <div class="text-h2 mb-2 text-primary text-center">
                  <v-icon color="primary">attach_file</v-icon>
                  <a :href="item.poa_anexo" target="_blank">
                    {{item.poa_nome}}
                  </a>
                </div>
                <v-divider class="my-3" v-if="i !== proposta.anexos.length - 1"></v-divider>
              </li>
            </ul>
          </div>
        </section>
        <section id="termos-e-condicoes" v-if="proposta && proposta.termos && proposta.termos.length > 0">
          <div class="container">
            <div class="text-h0 text-center mb-3" :style="'color:'+template.cores[6].tcc_cor">
              Termos e condições
            </div>
            <ul>
              <li v-for="(term, i) in proposta.termos" :key="i">
                <div class="text-h2 mb-2 text-primary">
                  <v-icon color="primary" small>fiber_manual_record</v-icon>
                  {{term.pot_titulo}}
                </div>
                <div class="text" v-html="term.pot_descricao">
                </div>
                <v-divider class="my-3" v-if="i !== proposta.termos.length - 1"></v-divider>
              </li>
            </ul>
          </div>
        </section>
        <section id="download" class="content_space hide-print">
          <div class="container">
            <div class="text-h0 text-center mb-3 text-white">
              Quer imprimir a proposta?
            </div>
            <div class="text text-center mb-3 text-white">
              Clique no botão abaixo e faça download da proposta em PDF.
            </div>
            <div class="text-center mt-8">
              <v-btn :style="'color:'+template.cores[3].tcc_cor" :color="template.cores[2].tcc_cor" @click="callPrint()">
                <v-icon class="mr-1">picture_as_pdf</v-icon>
                Fazer download da proposta
              </v-btn>
            </div>
          </div>
        </section>
        <section id="footer" class="content_space hide-print">
          <div class="container">
            <v-row justify="space-between" align="center" no-gutters class="mb-0">
              <div class="text text-white">
                StartIn 2023. Todos os direitos reservados.
              </div>
              <div class="text text-white">
                Proposta gerada no sistema StartIn
              </div>
            </v-row>
          </div>
        </section>
        <div class="whatsapp floating hide-print" v-if="proposta.integrador && proposta.integrador.int_celular">
          <a target="_blank" :href="'https://wa.me/55' + proposta.integrador.int_celular.replace('(','').replace(')', '').replace(' ','').replace('-','')">
            <img src="@assets/img/whatsapp.png" alt="Whatsapp">
          </a>
        </div>
      </div>
      <div class="assinatura_impressora show-print" v-if="proposta.integrador">
        <div class="container">
          <v-row justify="center">
            <v-col cols="8">
              <div class="text">
                De acordo com os produtos, valores e termos relatados nesta proposta e por estarem assim justo e contratados, {{proposta.integrador.int_nome_fantasia ? proposta.integrador.int_nome_fantasia : proposta.integrador.int_nome}} e o(a) {{proposta.cliente.cli_nome}} firmam a proposta.
              </div>
            </v-col>
            <v-col cols="12" class="py-0"></v-col>
            <v-col cols="4" class="mt-6 pr-5">
              <div class="assinatura text text--thin text-center">
                {{proposta.integrador.int_nome_fantasia ? proposta.integrador.int_nome_fantasia : proposta.integrador.int_nome}} <br>
                {{proposta.integrador.int_cnpj}}
              </div>
            </v-col>
            <v-col cols="4" class="mt-6 pl-5">
              <div class="assinatura text text--thin text-center">
                <div class="text text--thin">
                  {{proposta.cliente.cli_nome}} <br>
                  {{proposta.cliente.cli_cpf}}
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '@API'
import BarChart from '@components/graficos/BarChart.vue'
export default {
  components: {
    BarChart
  },
  data () {
    return {
      theme: false,
      loading: true,
      screenWidth: screen.width,
      proposta: [],
      template: [],
      parceiros: [],
      loadingParceiros: true,
      oportunidadeDimensionamento: [],
      loadingOportunidadeDimensionamento: true,
      loadingUnidadeConsumidora: true,
      dadosUnidadeConsumidora: [],
      loadingContasEnergia: true,
      dadosContasEnergia: [],
      dadosGraficoEstimativa: [],
      loadingGraficoEstimativa: false,
      propostaInvalida: false,
      modalidades: [
        {
          text: 'Grupo B - Convencional',
          value: 1
        },
        {
          text: 'Grupo A - Verde',
          value: 2
        },
        {
          text: 'Grupo A - Azul',
          value: 3
        }
      ],
      padroes: [
        {
          text: 'Monofásico',
          value: 1
        },
        {
          text: 'Bifásico',
          value: 2
        },
        {
          text: 'Trifásico',
          value: 3
        }
      ],
      tiposEstrutura: [
        {
          text: 'Carport Solar',
          value: 1
        },
        {
          text: 'Cerâmico',
          value: 2
        },
        {
          text: 'Fibrocimento',
          value: 3
        },
        {
          text: 'Laje',
          value: 4
        },
        {
          text: 'Metálico',
          value: 5
        },
        {
          text: 'Misto',
          value: 6
        },
        {
          text: 'Shingle',
          value: 7
        },
        {
          text: 'Solo',
          value: 8
        },
        {
          text: 'Outros',
          value: 9
        }
      ],
      menu: [
        {
          nome: 'Quem somos',
          slug: 'quem-somos'
        },
        {
          nome: 'Descrição da proposta',
          slug: 'descricao-da-proposta'
        },
        {
          nome: 'Produtos',
          slug: 'produtos'
        },
        {
          nome: 'Payback',
          slug: 'payback'
        },
        {
          nome: 'Termos e condições',
          slug: 'termos-e-condicoes'
        }
      ],
      barChartOptionskWh: {
        responsive: true,
        title: {
          display: true,
          position: 'left',
          text: ['kWh'],
          fontSize: 14
        }
      },
      barChartOptionsFluxoCaixa: {
        responsive: true,
        title: {
          display: true,
          position: 'left',
          text: ['Retorno (R$)'],
          fontSize: 14
        },
        legend: {
          position: 'top'
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              console.log(tooltipItem, 'datasetIndex')
              let formatter = new Intl.NumberFormat('pt-BR',
                {
                  style: 'currency',
                  currency: 'brl',
                  maximumFractionDigits: 2
                }
              )
              let formattedNumber = formatter.format(Number(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]))
              return formattedNumber
            }
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return value
              }
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Ano',
              fontSize: 16
            }
          }]
        }
      },
      barChartDataEstimativa: {},
      barChartData: {
        labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        datasets: [
          {
            label: 'Seu consumo',
            backgroundColor: '#004A93',
            data: [5.399, 5.349, 5.386, 4.86, 4.063, 3.619, 3.934, 4.732, 4.421, 4.931, 5.534, 5.491]
          },
          {
            label: 'Geração do sistema',
            backgroundColor: '#00B01A',
            data: [4.399, 4.349, 4.386, 3.86, 3.063, 4.619, 4.934, 3.732, 3.421, 5.931, 6.534, 6.491]
          }
        ]
      },
      barChartDataTwo: {
        labels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
        datasets: []
      },
      retornoInvestimento: [],
      retornoAnalise: null
    }
  },
  methods: {
    scrollToSection (item) {
      document.getElementById(item).scrollIntoView({
        behavior: 'smooth'
      })
    },
    retornaSoma (qtd, valor) {
      return Number(valor) * Number(qtd)
    },
    showOrHideMenu (slug) {
      if (slug === 'termos-e-condicoes') {
        if (this.proposta.termos && this.proposta.termos.length > 0) {
          return ''
        } else {
          return 'd-none'
        }
      } else if (slug === 'produtos') {
        if (this.proposta.produtos && this.proposta.produtos.length > 0) {
          return ''
        } else {
          return 'd-none'
        }
      } else {
        return ''
      }
    },
    callPrint () {
      window.print()
    },
    async getProposta () {
      this.loading = true
      this.propostaInvalida = false
      await Api.get(`propostas/${this.$route.params.uuid}/visualizacao`)
        .then(res => {
          if (res.data && res.data.proposta) {
            console.log('propostas', res.data.proposta)
            this.proposta = res.data.proposta
          }
          if (res.data && res.data.template) {
            console.log('templates', res.data.template)
            this.template = res.data.template
          }
          if (!res.data.integrador && !res.data.proposta.oportunidade) {
            this.propostaInvalida = true
            this.loading = false
            this.loadingParceiros = false
            this.loadingOportunidadeDimensionamento = false
            this.loadingUnidadeConsumidora = false
            this.loadingContasEnergia = false
            this.loadingGraficoEstimativa = false
            return false
          }
          this.getParceiros()
          this.getOportunidadeDimensionamento()
          this.getContasEnergia()
          this.getDadosUnidadeConsumidora()
          this.getDadosGraficoEstimativa()
          this.getDadosInvestimentoCaixa()
        })
        .catch(err => {
          this.loading = false
          this.loadingParceiros = false
          this.loadingOportunidadeDimensionamento = false
          this.loadingUnidadeConsumidora = false
          this.loadingContasEnergia = false
          this.loadingGraficoEstimativa = false
          if (err && err.response && err.response.status && err.response.status === 400) {
            this.propostaInvalida = true
          } else {
            this.$root.SnackControl.open(this, {
              text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar a proposta!',
              color: 'error'
            })
          }
          console.log(err)
        })
    },
    async getParceiros () {
      this.loadingParceiros = true
      await Api.get(`parceiros?integrador=${this.proposta.integrador.uuid_int_id}`)
        .then(res => {
          this.parceiros = res.data
          this.loadingParceiros = false
        })
        .catch(err => {
          this.loadingParceiros = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar a proposta!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getOportunidadeDimensionamento () {
      this.loadingOportunidadeDimensionamento = true
      await Api.get(`oportunidades/${this.proposta.oportunidade.uuid_opu_id}/dimensionamento/sugerido`)
        .then(res => {
          this.oportunidadeDimensionamento = res.data
          this.loadingOportunidadeDimensionamento = false
        })
        .catch(err => {
          this.loadingOportunidadeDimensionamento = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados do dimensionamento!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getContasEnergia () {
      this.loadingContasEnergia = true
      await Api.get(`oportunidades/${this.proposta.oportunidade.uuid_opu_id}/contas`)
        .then(res => {
          this.dadosContasEnergia = res.data
          this.loadingContasEnergia = false
        })
        .catch(err => {
          this.loadingContasEnergia = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados da tabela da unidade consumidora!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDadosUnidadeConsumidora () {
      this.loadingUnidadeConsumidora = true
      await Api.get(`oportunidades/${this.proposta.oportunidade.uuid_opu_id}/dimensionamento/tabela`)
        .then(res => {
          this.dadosUnidadeConsumidora = res.data
          this.loadingUnidadeConsumidora = false
        })
        .catch(err => {
          this.loadingUnidadeConsumidora = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados da tabela da unidade consumidora!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDadosGraficoEstimativa () {
      this.loadingGraficoEstimativa = true
      await Api.get(`oportunidades/${this.proposta.oportunidade.uuid_opu_id}/dimensionamento/grafico`)
        .then(res => {
          this.dadosGraficoEstimativa = res.data
          if (res.data.data) {
            this.barChartDataEstimativa = {
              labels: res.data.labels,
              datasets: [
                {
                  label: 'Geração do sistema',
                  backgroundColor: '#004A93',
                  data: res.data.data
                }
              ]
            }
            console.log(this.barChartDataEstimativa, 'this.barChartDataEstimativathis.barChartDataEstimativathis.barChartDataEstimativa')
          }
          this.loadingGraficoEstimativa = false
        })
        .catch(err => {
          this.loadingGraficoEstimativa = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados do gráfico de estimativa!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDadosInvestimentoCaixa () {
      this.loadingDadosInvestimentoCaixa = true
      await Api.get(`propostas/${this.proposta.uuid_pos_id}/relatorios`)
        .then(res => {
          if (res.data) {
            let dadosGrafico = res.data.caixa
            this.retornoInvestimento = res.data.retorno
            this.retornoAnalise = res.data.analise
            this.barChartDataTwo.datasets = dadosGrafico.datasets
          }
          this.loadingDadosInvestimentoCaixa = false
          this.loading = false
          setTimeout(() => {
            this.scrollToSection('inicio')
          }, 200)
        })
        .catch(err => {
          this.loadingDadosInvestimentoCaixa = false
          this.loading = false
          setTimeout(() => {
            this.scrollToSection('inicio')
          }, 200)
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados!',
            color: 'error'
          })
          console.log(err)
        })
    },
    retornaModalidade (item) {
      if (item) {
        let dados = this.modalidades.filter(dad => dad.value === item)
        if (dados[0]) {
          return dados[0].text
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    retornaEntrada (item) {
      if (item) {
        let dados = this.padroes.filter(dad => dad.value === item)
        if (dados[0]) {
          return dados[0].text
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    loadFunctions () {
      this.$vuetify.theme.dark = false
      this.theme = this.$vuetify.theme.dark
      this.getProposta()
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.container {
  max-width: 1200px;
  @media (max-width: 1200px){
    max-width: 100%;
    padding: 0 15px;
  }
}
#topo {
  align-items: center;
  background-color: rgb(231, 240, 246);
  box-shadow: 0px 0px 10px;
  display: flex;
  left: 0;
  height: 65px;
  position: fixed;
  top: 0;
  user-select: none;
  width: 100%;
  z-indeX: 20;
  @media (max-width: 767px){
    height: 45px;
  }
  img {
    max-height: 50px;
    max-width: 190px;
    @media (max-width: 767px){
      max-height: 30px;
      max-width: 100%;
      padding-left: 10px;
    }
  }
}
.menu_space {
  height: 65px;
  width: 100%;
  @media (max-width: 767px){
    height: 45px;
  }
}
.topo_proposta {
  align-items: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  min-height: 600px;
  position: relative;
  @media (max-width: 767px){
    min-height: 350px;
  }
  &:before {
    background-color: #313132;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    opacity: 0.4;
  }
  .content_move_topo {
    border-radius: 5px;
    backdrop-filter: blur(15px);
    margin: 0 auto;
    padding: 20px;
    width: fit-content;
  }
}
.logo_quem_somos {
  img {
    max-height: 150px;
    max-width: 500px;
  }
}
#quem-somos, #payback, #anexos {
  background: #fafafa;
}
.parceiros_imagens {
  img {
    max-height: 100px;
    max-width: 200px;
  }
}
#oque-nos-move {
  align-items: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  height: 600px;
  justify-content: center;
  position: relative;
  z-index: 10;
  @media (max-width: 1200px){
    height: inherit;
  }
}
.content_move {
  border-radius: 5px;
  backdrop-filter: blur(15px);
  padding: 20px;
}
#app {
  overflow: hidden;
}
.content_space {
  padding: 70px 0;
  @media (max-width: 1200px){
    padding: 50px 0;
  }
}
#descricao-da-proposta {
  background: $black;
}
.border_table_dark {
  border: 1px $graydark solid;
  &_right {
    border-right: 1px $graydark solid;
    padding-bottom: 10px!important;
    padding-top: 10px!important;
  }
  &_bottom {
    border-bottom: 1px $graydark solid;
    padding-bottom: 10px!important;
    padding-top: 10px!important;
  }
}
.border_table {
  border: 1px $graywhite solid;
  &_right {
    border-right: 1px $graywhite solid;
    padding-bottom: 10px!important;
    padding-top: 10px!important;
  }
  &_bottom {
    border-bottom: 1px $graywhite solid;
    padding-bottom: 10px!important;
    padding-top: 10px!important;
  }
}
.bancos_imagens {
  max-height: 50px;
  max-width: 120px;
}
.alert-success {
  background-color: #dff0d8;
  border-color: #d0e9c6;
  color: #3c763d;
}
.alert-warning {
  background-color: #fcf8e3;
  border-color: #faf2cc;
  color: #8a6d3b;
}
.alert-danger {
  background-color: #f2dede;
  border-color: #ebcccc;
  color: #a94442;
}
#download {
  background: $black;
}
#footer {
  background-color: #313132;
}
.grafico_print {
  position: absolute;
  left: -9000px;
  width: 730px;
}
.whatsapp {
  bottom: 5px;
  position: fixed;
  right: 15px;
  z-index: 50;
  img {
    max-width: 50px;
  }
}
.floating {
	animation-iteration-count:infinite;
	animation-duration: 1.3s;
	animation-name: floating-float, floating;
	}
	@keyframes floating {
	 0% {
	   -webkit-transform: translateY(-8px);
	   transform: translateY(-8px);
	 }
	 50% {
	   -webkit-transform: translateY(-4px);
	   transform: translateY(-4px);
	 }
	 100% {
	   -webkit-transform: translateY(-8px);
	   transform: translateY(-8px);
	 }
	}
	@keyframes floating-float {
	 100% {
	   -webkit-transform: translateY(-8px);
	   transform: translateY(-8px);
	 }
}
.assinatura_impressora {
  padding-top: 80px;
  text-align: justify;
  .assinatura {
    border-top: 2px #000 solid;
    padding-top: 3px;
  }
}
#termos-e-condicoes {
  padding: 70px 0;
  @media (max-width: 1200px){
    padding: 50px 0;
  }
}
.page_break {
  page-break-after: always;
}
@page {
  size: A4 portrait!important;
}

</style>



// WEBPACK FOOTER //
// src/pages/PropostaWeb.vue